export default {
  name: 'satisfaction-survey-alert',

  props: {
    likeHeartIcon: {
      type: String,
      required: true
    },
    isLoadingSurvey: {
      type: Boolean,
      required: true
    }
  },

  methods: {
    answerSurvey () {
      this.$emit('answer-survey')
    }
  }
}
